import React, {Component} from 'react';

class ActionNav extends Component {
  handleClick(name) {
    this.props.modeswitch(name);
  }

  render() {
    return (
      <nav className='bg-secondary pv2 border-box' id="skip-map">
        <ul className='mw8 ph2 center list pl0 ma0 primary lh-copy action-nav'>
          <li className='dib mr3 f5'><button className={this.props.mode === 'gaugeRecent' ? 'input-reset bg-transparent reset pa0 b' :'input-reset bg-transparent pa0 reset'} onClick={this.handleClick.bind(this, 'gaugeRecent')}>Recent Rainfall</button></li>
          <li className='dib mr3 f5'><button className={this.props.mode === 'gaugeDDF' ? 'input-reset bg-transparent reset pa0 b' : 'input-reset bg-transparent pa0 reset'} onClick={this.handleClick.bind(this, 'gaugeDDF')}>Recurrence Interval</button></li>
          <li className='dib f5'><button className={this.props.mode === 'radar' ? 'input-reset bg-transparent reset pa0 b' : 'input-reset bg-transparent pa0 reset'} onClick={this.handleClick.bind(this, 'radar')}>Radar-Rainfall</button></li>
        </ul>
      </nav>
    );
  }
}

export default ActionNav;



// WEBPACK FOOTER //
// ./src/components/ActionNav.js